import React, { useState } from "react";
import { useApiClient } from "../../../api";
import { IconButton, ListItem, ListItemText } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import AreYouSureDialog from "../../../shared-components/AreYouSureDialog";

export const MembershipsListItem = ({
  membership,
  schoolGroupMembership = false,
  schoolMembership = false,
  onDelete,
}) => {
  const ApiClient = useApiClient();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!schoolMembership && !schoolGroupMembership) {
    throw new Error(
      "Either schoolMembership or schoolGroupMembership must be true",
    );
  }

  const removeMembership = async () => {
    try {
      const result = await ApiClient.users.removeMembership({
        schoolGroupMembership: schoolGroupMembership ? membership.id : null,
        schoolMembership: schoolMembership ? membership.id : null,
      });

      if (result.success) {
        enqueueSnackbar("Successfully removed membership.", {
          variant: "success",
          autoHideDuration: 3000,
        });

        onDelete?.(membership.id);
      } else {
        enqueueSnackbar(result.message || "Failed to remove membership", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Error removing membership:", error);
      enqueueSnackbar("Error removing membership. Please try again.", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  const formatMembershipName = () => {
    if (schoolGroupMembership) {
      return `${membership.schoolGroup.name} (Group)`;
    }
    return `${membership.school.name} (School)`;
  };

  return (
    <>
      <AreYouSureDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        actionText="you want to remove this membership"
        onDelete={removeMembership}
        title={"Remove Membership"}
      />

      <ListItem
        secondaryAction={
          <IconButton
            edge="end"
            onClick={() => setDialogOpen(true)}
            sx={{ border: 0 }}
          >
            <Delete />
          </IconButton>
        }
        sx={{
          mb: 1,
        }}
      >
        <ListItemText primary={formatMembershipName()} />
      </ListItem>
    </>
  );
};
